// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__3dueu","container":"Dialog_container__2R4tN","content":"Dialog_content__3Rv2T","title":"Dialog_title__3ZoRa","closeButton":"Dialog_closeButton__1hZqR"};